import { formatDate } from "./caceriasFormat";

const isExpiredForCaceria = (dateStr, caceriaDate) => {
    if (!dateStr) return false;
    const d = new Date(dateStr);
    if (isNaN(d)) return false;
    d.setHours(0, 0, 0, 0);
    return d <= caceriaDate;
};

export const decorateCaceriasWithWarnings = ({ cacerias, personas }) => {
    const personasArr = Array.isArray(personas) ? personas : [];

    return (cacerias || []).map((c) => {
        const caceriaDate = new Date(c.fecha);
        caceriaDate.setHours(0, 0, 0, 0);

        const updatedParticipaciones = (c.participaciones || []).map((p) => {
            const personaId = p.persona?.id || p.persona;
            const personaFull = personasArr.find((per) => per.id === personaId);

            if (!personaFull) return { ...p, persona: { ...p.persona, tieneAdvertencia: false } };

            const fechas = [
                personaFull.fechaCaducidad,
                personaFull.fechaValidez,
                personaFull.fechaDeCaducidad,
                personaFull.fechaFin,
                personaFull.finVigencia,
                ...(personaFull.licenciasArmas?.map((l) => l.fechaValidez) || []),
                ...(personaFull.licenciasCaza?.map((l) => l.fechaCaducidad) || []),
                ...(personaFull.seguros?.map((s) => s.fechaDeCaducidad) || []),
            ];

            const tieneAdvertencia = fechas.some((f) => isExpiredForCaceria(f, caceriaDate));
            return { ...p, persona: { ...personaFull, tieneAdvertencia } };
        });

        return {
            ...c,
            participaciones: updatedParticipaciones,
            tieneAdvertencia: updatedParticipaciones.some((p) => p.persona?.tieneAdvertencia),
        };
    });
};

export const buildCaceriaEventoMap = (eventos) => {
    const m = new Map();
    (eventos || []).forEach((ev) => {
        (ev.cacerias || []).forEach((c) => {
            m.set(c.id, {
                id: ev.id,
                nombre: ev.nombre,
                fechaInicio: ev.fechaInicio,
                fechaFin: ev.fechaFin,
            });
        });
    });
    return m;
};

export const isCaceriaPasada = (caceria) => {
    if (!caceria?.fecha) return false;
    const d = new Date(caceria.fecha);
    if (isNaN(d.getTime())) return false;
    d.setHours(23, 59, 59, 999);
    return d.getTime() < Date.now();
};

export const deriveYears = (cacerias) => {
    const s = new Set((cacerias || []).map((c) => new Date(c.fecha).getFullYear()));
    s.add(new Date().getFullYear());
    return [...s].sort((a, b) => b - a);
};

// El servidor ya filtra por Pendientes/Pasados (ver fetchCaceriasAll(estado));
// aquí solo queda aplicar año y búsqueda sobre lo que haya llegado.
export const filterCacerias = ({ cacerias, q, selectedYear, eventos, caceriaEventoMap }) => {
    const term = (q || "").trim().toLowerCase();

    return (cacerias || [])
        .filter((c) => {
            const fecha = new Date(c.fecha);
            const y = fecha.getFullYear();
            const okYear = !selectedYear || y === Number(selectedYear);

            if (!term) return okYear;

            const fechaStr = formatDate(c.fecha).toLowerCase();
            const tipoStr = (c.tipoCaceria || "").toString().toLowerCase();

            const participantesStr = (c.participaciones || [])
                .map((p) => `${p.persona?.nombre || ""} ${p.persona?.apellidos || ""}`)
                .join(" ")
                .toLowerCase();

            const evFromCaceria =
                c.evento ||
                (c.eventoId && (eventos || []).find((e) => Number(e.id) === Number(c.eventoId))) ||
                caceriaEventoMap.get(c.id);

            const eventoNombreStr = (evFromCaceria?.nombre || "").toLowerCase();

            const searchBlob = [fechaStr, tipoStr, participantesStr, eventoNombreStr].join(" ");
            return okYear && searchBlob.includes(term);
        })
        .sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
};

export const deriveKpis = (list) => {
    const kpiTotal = list.length;
    const kpiConAlerta = list.filter((c) => c.tieneAdvertencia).length;
    const kpiParticipantes = list.reduce((acc, c) => acc + (c.participaciones?.length || 0), 0);
    return { kpiTotal, kpiConAlerta, kpiParticipantes };
};
